import React from 'react'

import {
    ComponentsDiv
} from '../Styles/Pages/NoMatchStyles'

import NoMatchDisp from '../Components/Display/NoMatchDisp'

function NoMatch(props){
    return (
        <>
            <ComponentsDiv>
                <NoMatchDisp />
            </ComponentsDiv>
        </>
    )
}

export default NoMatch;